import PropTypes from 'prop-types';
import React from 'react';

import NotificationContentContainer from './notification_content_container';
import AutoAcceptedSessionNotificationModel from 'models/notification/auto_accepted_session_notification';
import { iconClassFromSessionType } from 'components/lib/icon_classes';
import i18n from 'scripts/i18n/i18n';
import InteractionType from 'models/interaction_type';

class AutoAcceptedSessionNotification extends React.Component {
  render() {
    const notification = this.props.notification;
    return (
      <NotificationContentContainer
        body={this.getNotificationText()}
        heading={notification.profile.name || 'Customer'}
        iconClass={iconClassFromSessionType(notification.sessionType)}
        itemType={this.getItemTypeLabel()}
        notification={notification}
      />
    );
  }

  getNotificationText() {
    let sessionType = this.props.notification.sessionType;
    if (sessionType === InteractionType.ABANDONED_CALL || sessionType === InteractionType.VOICEMAIL) {
      return '';
    }
    return this.props.notification.messagePreview || 'New Message';
  }

  getItemTypeLabel() {
    switch (this.props.notification.sessionType) {
      case InteractionType.ABANDONED_CALL:
        return i18n.t('Abandoned call');
      case InteractionType.CHAT:
        return i18n.t('Chat');
      case InteractionType.EMAIL:
        return i18n.t('Email');
      case InteractionType.FB_COMMENT:
        return i18n.t('Facebook Comment');
      case InteractionType.FB_MESSENGER:
        return i18n.t('Facebook Message');
      case InteractionType.INSTAGRAM_DIRECT:
        return i18n.t('Instagram Message');
      case InteractionType.INSTAGRAM_COMMENT:
        return i18n.t('Instagram Comment');
      case InteractionType.SMS:
        return i18n.t('SMS');
      case InteractionType.TWITTER:
        return i18n.t('Twitter Message');
      case InteractionType.VOICEMAIL:
        return i18n.t('Voicemail');
      case InteractionType.WHATSAPP:
        return i18n.t('WhatsApp Message');
    }
  }
}

AutoAcceptedSessionNotification.propTypes = {
  notification: PropTypes.instanceOf(AutoAcceptedSessionNotificationModel).isRequired,
};

export default AutoAcceptedSessionNotification;
